import { render, staticRenderFns } from "./BtnViewInCart.vue?vue&type=template&id=21643152&"
import script from "./BtnViewInCart.vue?vue&type=script&lang=js&"
export * from "./BtnViewInCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports